import { render, staticRenderFns } from "./switch.vue?vue&type=template&id=e771d472"
import script from "./switch.vue?vue&type=script&lang=js"
export * from "./switch.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\baby_doctor_platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e771d472')) {
      api.createRecord('e771d472', component.options)
    } else {
      api.reload('e771d472', component.options)
    }
    module.hot.accept("./switch.vue?vue&type=template&id=e771d472", function () {
      api.rerender('e771d472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/QuickAdminTable/switch.vue"
export default component.exports